/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Lock_TitleInputs */



/**
* | output |
* | --- |
* | "Lock Record" |
*
* @param {Explorer_Info_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_title = /** @type {((inputs?: Explorer_Info_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouiller l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sperrdatensatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocca record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заблокировать запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloquear registro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("锁定记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードをロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉक रिकॉर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro de bloqueio")
	return /** @type {LocalizedString} */ ("Lock Record")
});